import app from './app'
import auth from './auth'
import checkout from './checkout'
import home from './home'
import user from './user'
import validations from './validations'
import order from './order'

export default { app, auth, checkout, home, user, validations, order }
